import { ButtonWithArrowRight, Footer, Title } from '~components';
import NumberedList, { NumberedListItem } from '~components/dumbs/NumberedList';

import * as Styled from './SelfieTutorial.styles';

function SelfieTutorial({
  onClickOpenCamera,
}: {
  onClickOpenCamera: () => void;
}) {
  const handleTakePicture = () => {
    onClickOpenCamera();
  };

  return (
    <>
      <Styled.Header>
        <Styled.FaceDetectionSvg />
        <Title>
          Agora precisamos <br /> de uma selfie sua
        </Title>
      </Styled.Header>

      <NumberedList>
        <NumberedListItem>Esteja em um local iluminado</NumberedListItem>
        <NumberedListItem>
          Não utilize nenhum acessório no rosto
        </NumberedListItem>
        <NumberedListItem>Centralize seu rosto na tela</NumberedListItem>
      </NumberedList>
      <Footer
        marginTop="auto"
        rightButton={
          <ButtonWithArrowRight
            width="100%"
            variant="primary"
            onClick={handleTakePicture}
            type="submit"
          >
            Tirar foto
          </ButtonWithArrowRight>
        }
      />
    </>
  );
}

export default SelfieTutorial;
